export default __webpack_public_path__ + "static/media/BetLightON.5579f655.png";